// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__MXeho","title":"ClientInsurance_title__1XKYH","itemText":"ClientInsurance_itemText__3RggV"};